import { Stack, Typography } from '@mui/material';
import React from 'react';
const Metrics = [
    {
        stats: '100k+',
        description: 'Grants & Foundations in our database',
    },
    {
        stats: '500+',
        description: 'Businesses helped',
    },
    {
        stats: '$200M+',
        description: 'In won funding',
    },
];
export const SuccessMetrics = () => {
    return (React.createElement(Stack, { mt: 6, gap: 2, width: "100%", maxWidth: "700px", direction: { xs: 'column', sm: 'row' }, justifyContent: { xs: 'center', sm: 'space-between' } }, Metrics.map(({ stats, description }) => (React.createElement(Stack, { key: stats, maxWidth: { xs: '100%', sm: '170px' }, alignItems: "center" },
        React.createElement(Typography, { fontSize: "2rem", fontWeight: 600, color: "primary" }, stats),
        React.createElement(Typography, { textAlign: "center", fontSize: "1rem", fontWeight: 500, color: "secondary.light" }, description))))));
};
